// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.p-input-icon-right {
  display: block;
  width: 100%;
}
.p-input-icon-right > .p-inputtext {
  width: 100%;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/app/data/components/data-table/data-table-filter.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;AACJ;;AAEA;EACI,cAAA;EACA,WAAA;AACJ;AACI;EACI,WAAA;EACA,sBAAA;AACR","sourcesContent":[":host {\r\n    display: block;\r\n    width: 100%;\r\n}\r\n\r\n.p-input-icon-right {\r\n    display: block;\r\n    width: 100%;\r\n\r\n    > .p-inputtext {\r\n        width: 100%;\r\n        box-sizing: border-box;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
